import map from 'lodash/map';

import { DataLayerServiceModule } from './dataLayer.service';

export const ProductsTrackerServiceModule = angular
    .module('app.services.tracking.enhancedEcommerce.productsTracker', [
        DataLayerServiceModule
    ]).factory('productsTracker', ($window, dataLayer) => {
        function logProductImpression(products, categoryName, listType) {
            let impressions = map(products, (item, index) => {
                return dataLayer.create(item, categoryName, listType, index + 1);
            });
            dataLayer.logProductImpression(impressions);
        }

        function logProductClick(product, categoryName, listType, position) {
            if (angular.isDefined(position) && isFinite(parseInt(position))) {
                position = parseInt(position);
            }
            let payload = dataLayer.create(product, categoryName, listType, position);

            dataLayer.logProductClick([payload], listType);
        }

        function logProductDetails(product, categoryName, listType) {
            let impression = dataLayer.create(product, categoryName, listType);
            dataLayer.logProductDetails([impression], listType);
        }

        return {
            logProductImpression,
            logProductClick,
            logProductDetails
        };
    }).name;




// WEBPACK FOOTER //
// ./src/app/services/tracking/enhancedEcommerce/productsTracker.service.js